import { useEffect, useRef, useState } from 'react'

interface UseScrollAnimationOptions {
	threshold?: number
	rootMargin?: string
}

export const useScrollAnimation = (
	options: UseScrollAnimationOptions = {}
) => {
	const { threshold = 0.15, rootMargin = '-50px' } = options
	const ref = useRef<HTMLElement>(null)
	const [isVisible, setIsVisible] = useState(false)

	useEffect(() => {
		const observer = new IntersectionObserver(
			([entry]) => {
				setIsVisible(entry.isIntersecting)
			},
			{ threshold, rootMargin }
		)

		const currentElement = ref.current

		if (currentElement) {
			observer.observe(currentElement)
		}

		return () => {
			if (currentElement) {
				observer.unobserve(currentElement)
			}
		}
	}, [threshold, rootMargin])

	return { ref, isVisible }
}

